import { Button } from "antd";
import GainIcon from "../gainicon";

export default function AddButton({ label, onClick,hidden }) {
  return (
    <Button
      className={`text-white bg-primary border-none font-light px-10 py-2 h-full rounded-lg flex items-center ml-5 ${hidden ? `` : `hidden`}`}
      icon={<GainIcon name="add" />}
      onClick={onClick}
    >
      <span className="pl-2">{label}</span>
    </Button>
  );
}
